<template>
  <div>
    <SwapDevice
      v-if="openSwap"
      :show="openSwap"
      v-on:closeSwap="openSwap = false"
      v-on:showMsg="showMsg"
    />
    <ConfirmModal
      :msg="$t('confirm_export', { date, downloadTo })"
      :show="showConfirm"
      :heading="$t('export_history')"
      :btnTxt="$t('yes_export')"
      @close="showConfirm = false"
      @submit="exportReport"
      is-yellow
    />

    <timezone
      :show="show_time"
      @openExport="openExport"
      @close="show_time = false"
      :downloadTo.sync="downloadTo"
      :selectedExportFormat.sync="selectedExportFormat"
    />

    <SuccessModal
      :show="showSuccessPopup"
      @close="showSuccessPopup = false"
      :msg="successMsg"
      :heading="successHeading"
      is-export
    />

    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>
    <div class="page-wrapper">
      <div class="page-breadcrumb sticky-breadcrumb">
        <div class="row">
          <div class="col-md-5 align-self-center col-sm-4 col-12">
            <ul class="breadcrumb mb-2 list-style-none">
              <li
                class="breadcrumb-item h6 font-16 mylink"
                style="margin-right: 3rem"
              >
                <router-link
                  class="mylink"
                  :to="'/devices/' + this.$route.params.device_id + '/details'"
                  >{{ $t("details") }}</router-link
                >
              </li>
              <li
                class="breadcrumb-item h6 font-16 mylink"
                style="margin-right: 3rem"
              >
                <router-link
                  class="mylink"
                  :to="
                    '/devices/' + this.$route.params.device_id + '/excursions'
                  "
                  >{{ $t("excursions") }}</router-link
                >
              </li>
              <li
                class="breadcrumb-item h6 font-16 mylink"
                style="margin-right: 3rem"
                v-if="!singledevice.isDecommissioned && !hasStartAndEnd"
              >
                <router-link
                  class="mylink"
                  :to="'/devices/' + this.$route.params.device_id + '/settings'"
                  >{{ $t("settings") }}</router-link
                >
              </li>
            </ul>
          </div>
          <div
            class="col-md-7 align-self-center col-sm-8 col-12"
            v-if="singledevice"
          >
            <div
              class="date-export align-items-center justify-content-end py-2"
            >
              <date-component
                class="mr-4 date"
                @period="handlePeriodChange"
                v-if="this.$route.name == 'DeviceDetails'"
                :max-date="maxDate"
                :min-date="minDate"
              />
              <div class="position-relative">
                <button
                  class="btn btn-secondary mr-3"
                  @click.stop="show_time = !show_time"
                  :disabled="!startdate && !enddate"
                  v-if="this.$route.name == 'DeviceDetails'"
                >
                  {{ $t("export") }}
                </button>
                <!-- <div
                  class="dropdown-lang position-absolute p-20 pt-3"
                  v-if="show_formats"
                  v-click-outside="closeExport"
                >
                  <div class="export-container">
                    <div
                      class="export-item"
                      v-for="format in formats"
                      :key="format.value"
                    >
                      <input
                        type="checkbox"
                        :id="format.value"
                        :checked="selectedExportFormat.includes(format.value)"
                        @change="handleToggleExportFormat(format.value)"
                      />
                      <label :for="format.value">
                        {{ format.label }}
                      </label>
                    </div>
                  </div>

                  <button
                    class="export-btn"
                    @click="handleExportClicked"
                    :disabled="selectedExportFormat.length === 0"
                  >
                    <span>{{ $t("export") }}</span>
                    <ArrowRightColored />
                  </button>
                </div> -->
              </div>

              <button
                class="btn btn-primary nowrap"
                @click="openSwap = true"
                v-if="!singledevice.isDecommissioned && !hasStartAndEnd"
              >
                {{ $t("device_swap") }}
              </button>
            </div>
          </div>
        </div>

        <!-- <NotificationBox
          :mssg="successMsg"
          :errorMssg="errorMssg"
          v-if="successMsg || errorMssg"
        /> -->
      </div>

      <router-view
        :singledevice="singledevice"
        @pageChange="pageChange"
        :devicehistoryChart="devicehistoryChart"
        :deviceHistoryChartMeta="deviceHistoryChartMeta"
        :chartLimit="chartLimit"
        @limitChange="limitChange"
        @handlePageChangeChart="pageChangeChart"
        :chartPageNumber="chartPageNumber"
        :mapPoints="mapPoints"
      />

      <footer class="footer text-center">
        &#169;{{ new Date().getFullYear() }} {{ $t("all-rights") }}
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import SwapDevice from "../Modals/SwapDevice.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import DateComponent from "../../components/DateComponent.vue";
import ConfirmModal from "../Modals/ConfirmModal.vue";
import SuccessModal from "../Modals/SuccessModal.vue";
import Timezone from "../Modals/Timezone.vue";
import ArrowRightColored from "../../components/Iconsvg/ArrowRightColored.vue";

export default {
  name: "ViewDevice",
  data() {
    return {
      isLoading: true,
      fullPage: true,
      openSwap: false,
      successMsg: "",
      errorMssg: "",
      startdate: "",
      enddate: "",
      params: {
        limit: 10,
        page: 1,
      },
      showConfirm: false,
      showSuccessPopup: false,
      show_time: false,
      formats: [
        { label: "Export as PDF", value: "pdf" },
        { label: "Export as CSV", value: "csv" },
        { label: "Export as ASCII", value: "ascii" },
        { label: "Export as HTML", value: "html" },
        { label: "Export as JPEG", value: "jpeg" },
        { label: "Export as PDF-Log", value: "pdf-log" },
      ],
      currentFormat: "",
      show_formats: false,
      selectedExportFormat: [],
      devicehistoryChart: [],
      deviceHistoryChartMeta: {},
      chartLimit: 2000,
      chartPageNumber: 1,
      mapPoints: {},
      downloadTo: "",
      successHeading: "",
    };
  },
  components: {
    Loading,
    SwapDevice,
    // NotificationBox,
    ArrowRightColored,
    DateComponent,
    ConfirmModal,
    SuccessModal,
    Timezone,
  },
  mounted() {
    this.fetchDeviceDetails({ device_id: this.$route.params.device_id })
      .then(() => {
        this.isLoading = false;
      })
      .catch((error) => {
        this.isLoading = false;
        if (error.response) {
          //console.log(error.response);
          this.$router.push("/404");
        }
      });
  },
  computed: {
    ...mapGetters([
      "profile",
      "singledevice",
      "currentTimezone",
      "selectedSession",
    ]),
    date() {
      return `${moment(this.startdate).format("DD/MM/YY")} - ${moment(
        this.enddate,
      ).format("DD/MM/YY")}`;
    },
    email() {
      return this.profile.email;
    },
    removePageParam() {
      const chartSettings = this.profile.company.chartDateTimeSettings;
      return chartSettings === "transmissionStartDate" && this.startdate
        ? true
        : false;
    },
    maxDate() {
      if (this.singledevice?.decommissionedAt) {
        return this.singledevice?.decommissionedAt;
      }
      if (this.hasStartAndEnd) {
        return this.endDate;
      }
      return null;
    },
    minDate() {
      if (this.hasStartAndEnd) {
        return this.startDate;
      }
      return null;
    },
    hasStartAndEnd() {
      return this.startDate && this.endDate;
    },
    startDate() {
      return this.selectedSession?.startDate || null;
    },
    endDate() {
      return this.selectedSession?.endDate || null;
    },
  },
  methods: {
    ...mapActions([
      "fetchDeviceDetails",
      "getDeviceHistory",
      "getDeviceHistoryChart",
      "getDeviceHistoryMapPoints",
      "getDeviceReportByEmail",
      "resetHistoryChart",
      "correctGoogleMapLocation",
      "exportDevices",
      "clearSelectedSession",
    ]),
    showMsg() {
      this.mssg = "";
      setTimeout(() => {
        this.mssg = "";
      }, 4000);
    },
    handleToggleExportFormat(newFormat) {
      this.selectedExportFormat = this.selectedExportFormat.includes(newFormat)
        ? this.selectedExportFormat.filter((format) => format !== newFormat)
        : [newFormat, ...this.selectedExportFormat];
    },
    handleExportClicked() {
      if (this.selectedExportFormat.length === 0) return;
      this.show_formats = false;
      this.show_time = true;
    },
    exportReport() {
      this.isLoading = true;
      const id = this.$route.params.device_id;
      let data = {
        email: this.profile.email,
        startDate: this.startdate || undefined,
        endDate: this.enddate || undefined,
        timeZone: this.currentTimezone,
        formats: this.selectedExportFormat,
      };

      if (this.downloadTo === "computer") {
        data = {
          ...data,
          deviceId: id,
          format: this.selectedExportFormat[0],
          startDate: this.startdate
            ? moment(this.startdate).utc().format("YYYY-MM-DDTHH:mm:ss[Z]")
            : undefined,
          endDate: this.enddate
            ? moment(this.enddate).utc().format("YYYY-MM-DDTHH:mm:ss[Z]")
            : undefined,
        };
        delete data.email;
        delete data.formats;
      }
      if (this.downloadTo === "email") {
        this.getDeviceReportByEmail({ data, id })
          .then(() => {
            // this.successMsg = res.data.payload.message;
            this.isLoading = false;
            this.showSuccessPopup = true;
            this.showConfirm = false;
            this.currentFormat = "";
            this.successMsg = this.$t("email_dev_history", {
              email: this.profile.email,
            });
            this.successHeading = this.$t("check_email");
          })
          .catch((error) => {
            this.isLoading = false;
            this.isFilter = false;
            setTimeout(() => {
              this.errorMssg = "";
            }, 10000);
            if (error.response) {
              console.error(error.response.data.message);
            }
          });
      } else {
        this.exportDevices({ ...data })
          .then((res) => {
            this.isLoading = false;
            this.showSuccessPopup = true;
            this.showConfirm = false;
            this.currentFormat = "";
            this.downloadFile(res.data.payload.data);
            this.successMsg = this.$t("downloaded_to_computer");
            this.successHeading = this.$t("check_computer");
          })
          .catch((error) => {
            this.isLoading = false;
          });
      }
    },
    downloadFile(fileData) {
      try {
        const fileBase64 = fileData?.fileBase64;
        const fileName = fileData?.fileName;
        const contentType = fileData?.contentType;

        if (!fileBase64) {
          throw new Error("File data not found in response");
        }

        const blob = this.base64ToBlob(
          fileBase64,
          contentType || "application/octet-stream",
        );

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        const downloadFileName =
          fileName ||
          `device_export_${Date.now()}.${this.getFileExtension(contentType)}`;
        link.setAttribute("download", downloadFileName);

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading file:", error);
        this.error = "Failed to download file. Please try again.";
      }
    },
    getFileExtension(contentType) {
      const mimeMap = {
        "text/csv": "csv",
        "application/pdf": "pdf",
        "image/png": "png",
        "text/html": "html",
        "text/plain": "txt",
      };
      return mimeMap[contentType] || "bin";
    },
    base64ToBlob(base64, mimeType) {
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      return new Blob([byteArray], { type: mimeType });
    },
    pageChange(params) {
      this.isLoading = true;
      let period = {
        device: this.$route.params.device_id,
      };
      let start = this.startdate || this.startDate;
      let end = this.enddate || this.endDate;
      let startDate = start ? `${start}` : undefined;
      let endDate = end ? `${end}` : undefined;
      const payload = {
        ...params,
        startDate: startDate ? startDate : undefined,
        endDate: endDate ? endDate : undefined,
        filterOperator: "and",
      };

      this.params = params;
      // this.gethistory({ endDate, startDate, pageSize: params });
      this.getDeviceHistory({ period, params: payload }).then(
        () => (this.isLoading = false),
      );
    },
    gethistory({ endDate, startDate, pageSize }) {
      let period = {
        device: this.$route.params.device_id,
      };
      const params = {
        ...pageSize,
        startDate: startDate ? startDate : undefined,
        endDate: endDate ? endDate : undefined,
        filterOperator: "and",
      };
      this.resetHistoryChart();
      this.getDeviceHistory({ period, params }).then(
        () => (this.isLoading = false),
      );
      const chartSettings = this.profile.company.chartDateTimeSettings;
      const last24 = {
        startDate: this.startdate ? this.startdate : undefined,
        endDate: this.enddate ? this.enddate : undefined,
      };
      const transmissionStartDate = {
        sortOrder: "ASC",
        startDate: this.startdate ? this.startdate : undefined,
        endDate: this.enddate ? this.enddate : undefined,
      };
      const chartParam =
        chartSettings === "transmissionStartDate"
          ? transmissionStartDate
          : last24;
      this.chartPageNumber = 1;
      this.getDeviceHistoryChart({
        period,
        params: {
          ...chartParam,
          filterOperator: "and",
          limit: this.chartLimit,
          page: this.removePageParam ? undefined : 1,
        },
      }).then((res) => {
        this.devicehistoryChart = res.data.payload.data;
        this.deviceHistoryChartMeta = res.data.payload.meta;
      });
      this.getDeviceHistoryMapPoints({
        period,
        params: { endDate: params.endDate, startDate: params.startDate },
      }).then((res) => {
        const payloadLatLng = res.data.payload.waypoints?.map(
          ({ location }) => {
            return {
              latitude: location.lat,
              longitude: location.lng,
              timestamp: location.timestamp,
            };
          },
        );
        const start = {
          latitude: res.data.payload.start.lat,
          longitude: res.data.payload.start.lng,
          timestamp: res.data.payload.start.timestamp,
        };
        const end = {
          latitude: res.data.payload.end.lat,
          longitude: res.data.payload.end.lng,
          timestamp: res.data.payload.end.timestamp,
        };
        const payload = {
          locations: [start, ...payloadLatLng, end],
          maps: true,
        };

        if (
          res.data.payload.waypoints.length > 0 &&
          this.singledevice &&
          this.singledevice.type.toLowerCase() !== "lora" &&
          this.singledevice.type.toLowerCase() !== "glog5"
        ) {
          this.correctGoogleMapLocation({
            locations: payload,
          }).then((res) => {
            const waypoints = res.data.corrected_locations.map((location) => {
              return {
                location: {
                  lat: location.latitude,
                  lng: location.longitude,
                },
              };
            });
            this.mapPoints = {
              start: {
                lat: res.data.corrected_locations[0].latitude,
                lng: res.data.corrected_locations[0].longitude,
              },
              end: {
                lat: res.data.corrected_locations[
                  res.data.corrected_locations.length - 1
                ].latitude,
                lng: res.data.corrected_locations[
                  res.data.corrected_locations.length - 1
                ].longitude,
              },
              waypoints,
            };
          });
        }
      });
    },
    handlePeriodChange({ startdate = this.startDate, enddate = this.endDate }) {
      this.startdate = startdate;
      this.enddate = enddate;

      this.isLoading = true;
      this.gethistory({
        endDate: enddate,
        startDate: startdate,
        pageSize: this.params,
      });
    },
    openExport() {
      this.show_time = false;
      this.showConfirm = true;
    },
    formatClicked(format) {
      this.currentFormat = format;
      this.show_formats = false;
      this.show_time = true;
    },
    closeExport() {
      this.show_formats = false;
    },
    limitChange(limit) {
      this.chartLimit = +limit;
    },
    pageChangeChart(params) {
      this.isLoading = true;
      const period = {
        device: this.$route.params.device_id,
      };
      const chartSettings = this.profile.company.chartDateTimeSettings;
      const last24 = {
        startDate: this.startdate ? this.startdate : undefined,
        endDate: this.enddate ? this.enddate : undefined,
      };
      const transmissionStartDate = {
        sortOrder: "ASC",
      };
      const chartParam =
        chartSettings === "transmissionStartDate"
          ? transmissionStartDate
          : last24;
      this.chartPageNumber = +params.page;
      this.chartLimit = +params.limit;
      const payload = {
        ...chartParam,
        filterOperator: "and",
        limit: this.chartLimit,
        page: this.chartPageNumber,
      };
      this.getDeviceHistoryChart({
        period,
        params: payload,
      }).then((res) => {
        this.devicehistoryChart = res.data.payload.data;
        this.deviceHistoryChartMeta = res.data.payload.meta;
        this.isLoading = false;
      });
    },
  },
  watch: {
    chartLimit() {
      const chartSettings = this.profile.company.chartDateTimeSettings;
      const last24 = {
        startDate: this.startdate ? this.startdate : undefined,
        endDate: this.enddate ? this.enddate : undefined,
      };
      const transmissionStartDate = {
        sortOrder: "ASC",
      };
      const chartParam =
        chartSettings === "transmissionStartDate"
          ? transmissionStartDate
          : last24;

      const params = {
        ...chartParam,
        filterOperator: "and",
        limit: this.chartLimit,
        page: this.removePageParam ? undefined : this.chartPageNumber,
      };
      this.isLoading = true;

      this.getDeviceHistoryChart({
        period: {
          device: this.$route.params.device_id,
        },
        params,
      }).then((res) => {
        this.devicehistoryChart = res.data.payload.data;
        this.deviceHistoryChartMeta = res.data.payload.meta;
        this.isLoading = false;
      });
    },
    hasStartAndEnd() {
      if (this.startDate && this.endDate) {
        console.log(this.startDate, this.endDate);
        this.startdate = this.startDate;
        this.enddate = this.endDate;
        this.gethistory({
          endDate: this.endDate,
          startDate: this.startDate,
          pageSize: this.params,
        });
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== "DeviceSessionHistory") this.clearSelectedSession();
    next();
  },
};
</script>

<style scoped>
.mylink {
  color: #213e7a !important;
  font-size: 14px !important;
  text-decoration-color: #213e7a !important;
}
.mylink :hover {
  color: #213e7a !important;
  text-decoration: underline;
  text-underline-offset: 5px;
  text-decoration-color: #213e7a !important;
}
.router-link-exact-active.router-link-active {
  text-decoration: underline !important;
  color: #213e7a !important;
  cursor: default;
  text-underline-offset: 5px;
}
.swap {
  background-color: white !important;
  border-color: #213e7a !important;
  color: #213e7a !important;
}
.date-export {
  display: flex;
}

.sticky-breadcrumb {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: rgba(249, 250, 251, 1);
}

.timezone-container {
  font-size: 14px;
}

.timezone {
  padding: 10px 5px;
  cursor: pointer;
}

.timezone:hover {
  background: #dee2eb;
  color: #213e7a;
}

.dropdown-lang {
  background: #ffffff;
  box-shadow: 0px 20px 50px rgba(29, 53, 71, 0.06);
  border-radius: 3px;
  z-index: 3 !important;
  top: 51px;
  color: #5e6a79;
  width: max-content;
}

.export-item {
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;

  color: #404a57;
}
.export-item:not(:last-child) {
  margin-bottom: 10px;
}
.export-item label {
  margin-bottom: 0px;
  font: inherit;
}
.export-item input {
  width: 18px;
  height: 18px;
  border-radius: 0px;
  cursor: pointer;
}
.export-btn {
  display: flex;
  align-items: center;
  color: #213e7a;
  gap: 10px;
  margin-top: 20px;
  transition: gap 0.3s;
  background-color: transparent;
  border: 0;
  font-weight: 600;
  outline: none;
}
.export-btn:focus {
  outline: none;
}
.export-btn:hover {
  gap: 15px;
}

@media (max-width: 767.98px) {
  .date-export {
    flex-wrap: wrap;
    justify-content: flex-start !important;
    row-gap: 12px;
  }
  .breadcrumb .breadcrumb-item {
    margin-right: 1.5rem !important;
  }
}

@media (max-width: 500px) {
  .date-export {
    display: block;
  }

  .date {
    margin-bottom: 20px;
  }

  .date-export .btn {
    width: 100%;
    margin-right: 0 !important;
    margin-bottom: 10px;
  }
}
</style>
